import React from 'react';
import IconButton from '@mui/material/IconButton';
import { colorPalette } from '@directv-digital/dds.ui.dtv-theme';

interface NumberButtonProps {
  label: string;
  value?: number;
  width?: number;
  height?: number;
  selected?: boolean;
  disabled?: boolean;
  onClick: (value: number) => void;
  sx?: any
}
const NumberButton = ({
  label,
  value,
  width,
  height,
  selected,
  disabled,
  onClick,
  sx
}: NumberButtonProps) => (
    <IconButton
      disabled={disabled || false}
      disableRipple
      onClick={() => onClick(value)}
      sx={{
        "& .MuiIconButton-root": {
          flexBasis: `${height || "63"}px !important`
        },
        fontFamily: "PFDinMed",
        fontSize: "24px !important",
        height: `${height || "63"}px !important`,
        width: `${width || "63"}px !important`,
        borderRadius: "8px",
        color: "#000",
        boxShadow: "0px 2px 20px 0px rgba(0, 0, 0, 0.08)",
        transition: "background-color 150ms ease-in-out, border 200ms ease-in-out",
        backgroundColor: sx?.backgroundColor || "#FFFFFF",
        "&:hover": {
          backgroundColor: "#ECF3FB"
        },
        ...selected && {
          backgroundColor: "#ECF3FB",
          border: `2px solid ${colorPalette.blue[600]}`
        },
        "&:disabled": {
          backgroundColor: colorPalette.neutral[300],
          color: colorPalette.neutral[500]
        },
        "& .Mui-focusVisible, &:focus-visible": {
          backgroundColor: sx?.backgroundColor || "#FFFFFF",
          border: "3px solid #3885E1"
        },
        ...sx
      }}
    >{label}</IconButton>
)

export default React.memo(NumberButton);
